import utility from 'src/utils/utility'
import { useContext, useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import UserContext from 'src/provider/state-manager/userProvider'
import ApiContext from 'src/provider/API/call-service'
import './dashboard.scss'
import { Header, HeaderD2, HeaderD3, ProfileNewPassword, ProfileSecurityQuestion, Sidebar, SidebarD2 } from 'src/component'
import access from 'src/utils/localAccess'
import { useIdleTimer } from 'react-idle-timer'
import { appSettings, institutionConfig } from 'src/provider/config/constant'
import helpers from 'src/utils/helpers'
import { useGetCbpProfile } from 'src/hooks/cbp/useGetCbpProfile'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'

export const DashboardRoutes = () => {
    const navigate = useNavigate()
    const {notifier} = useContext(VisibilityContext)
    const {API} = useContext(ApiContext)
    const {info, recoverStatesData, logout, setInfoProperty} = useContext(AppInfoContext)
    const {user: {userInfo}} = useContext(UserContext)
    const [isAuth, setIsAuth] = useState(!!info.authToken)
    const [hasCompletedOnboarding, setHasCompletedOnboarding] = useState(true)
    const [forcePasswordReset, setForcePasswordReset] = useState(false)
    const { data: cbpProfile, isError, error } = useGetCbpProfile()

    useEffect(() => {
        if (isError && error) {
            const errorMessage = (error as Error).message || "An unknown error occurred";
            notifier.show(errorMessage);
        }
    }, [isError, error]);


    const componentInfo: any = {
        class: {
            1: 'dashboard-container',
            2: 'dashboard-container-d2',
            3: 'dashboard-container-d3'
        },
        moduleClass: {
            1: 'dashboard-modules',
            2: 'dashboard-modules',
            3: 'dashboard-modules-d3'
        },
        header: {
            1: <Header />,
            2: <HeaderD2 />,
            3: <HeaderD3 />
        },
        sideBar: {
            1: <Sidebar />,
            2: <SidebarD2/>,
            3: null
        }
    }

    useEffect(() => {
        setHasCompletedOnboarding(userInfo?.profileInfo?.isOnboardingCompleted)
        if (userInfo?.profileInfo?.isOnboardingCompleted) setForcePasswordReset(userInfo?.profileInfo?.isResetActive)
    }, [userInfo])

    useEffect(() => {
        recoverStatesData()
        if (!info.institutionData?.id) API.getInstitution()
        handleAuth()
        access.setNavigationAccess(navigate)
        access.setLogoutHandler(logout)
    }, [])
    
    // useEffect(()=>{
    //     const savedCbpState = sessionStorage.getItem('cbpState');
    //     if(savedCbpState){
    //         setInfoProperty('cbp', JSON.parse(savedCbpState));
    //     }
    // },[])

    async function handleAuth () {
        const [authToken, sessionExpiryTime] = await Promise.all([
            localStorage.getItem('authToken'),
            localStorage.getItem('session-expiry-time')
        ])

        let isSessionExpire = false
        const currentDate = new Date()
        //currentDate.setTime( currentDate.getTime() - new Date().getTimezoneOffset() * 60 * 1000 );

        if (sessionExpiryTime) {
            if (currentDate > new Date(sessionExpiryTime)) isSessionExpire = true
        }

        setIsAuth(!!authToken)
        
        if (!authToken || isSessionExpire) logout()
    }

    const onAction = () => helpers.setSessionExpiryTime(institutionConfig[info?.institutionData.alias as keyof typeof institutionConfig]?.SESSION_EXPIRATION_LENGTH)
    const onActive = () => {}
    const onIdle = () => logout()

    const idleTimer = useIdleTimer({
        timeout: institutionConfig[info?.institutionData.alias as keyof typeof institutionConfig]?.INACTIVITY_TIME || appSettings.INACTIVITY_TIME,
        onIdle,
        onActive,
        onAction,
        debounce: 500
    })

    const shouldHideSidebarAndHeader = info.cbp === true && (cbpProfile?.status !== "Approved" || cbpProfile?.status !== 'AmlScreeningPassed') 
    
    return (
        <>
            { isAuth &&
                <div className={shouldHideSidebarAndHeader ? 'cbp-onboarding-dashboard' : (componentInfo.class[info?.institutionData.design] || "dashboard-container")}>
                    {!shouldHideSidebarAndHeader && (componentInfo.header[info?.institutionData.design] || <Header />)}
                    {!shouldHideSidebarAndHeader && componentInfo.sideBar[info?.institutionData.design]}
                    { !hasCompletedOnboarding &&
                        <ProfileSecurityQuestion 
                            close={() => null} 
                        />
                    }
                    { forcePasswordReset &&
                        <ProfileNewPassword 
                            close={() => null} 
                        />
                    }
                    <div className={componentInfo.moduleClass[info?.institutionData.design] || "dashboard-modules"}>
                        <Outlet/>
                    </div>
                </div>
            }
        </>
    )
}

export default utility.routeData('dashboard', 'Dashboard', <DashboardRoutes/>)
